import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDGVohEEPeg8ER-f4jv2GAQ4ePMSlso5KY",
  authDomain: "invoice-app-b166d.firebaseapp.com",
  projectId: "invoice-app-b166d",
  storageBucket: "invoice-app-b166d.firebasestorage.app",
  messagingSenderId: "858278642823",
  appId: "1:858278642823:web:8973c4b9f428b799fc2422"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
